import React from 'react';
import { IMapPoint } from '../../../models/interfaces/IMapPoint';
import RichWaypoint from './WayPointTypes/RichWaypoint';
import GenericWaypoint from './WayPointTypes/GenericWaypoint';
import MinimumWaypoint from './WayPointTypes/MinimumWaypoint';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';

type WaypointProps = {
	waypoint: IMapPoint;
	i: number;
};

const Waypoint: React.FC<WaypointProps> = ({ waypoint, i }) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	const renderWaypoint = (waypoint: IMapPoint) => {
		// What media does the waypoint have?
		const wm = {
			has_video: waypoint.poi_video ? true : false,
			has_audio: waypoint.poi_audio ? true : false,
			has_image: waypoint.poi_image ? true : false,
		};
		if (network_status) {
			switch (true) {
				case wm.has_video:
					return (
						<RichWaypoint
							waypoint={waypoint}
							index={i}
							icon={'video'}
						/>
					);
					break;
				case wm.has_audio:
					return (
						<RichWaypoint
							waypoint={waypoint}
							index={i}
							icon={'audio'}
						/>
					);
					break;
				case wm.has_image:
					return <GenericWaypoint waypoint={waypoint} index={i} />;
					break;
				default:
					return <MinimumWaypoint waypoint={waypoint} index={i} />;
					break;
			}
		} else {
			// Here we should check for cached assets?
			return <MinimumWaypoint waypoint={waypoint} index={i} />;
		}
	};
	return <>{renderWaypoint(waypoint)}</>;
};

export default Waypoint;
